import React, { Component } from 'react';
import firebase from '../../helper/firebase';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import {
	// Avatar,
	Button,
	Card,
	CardActions,
	// Checkbox,
	CircularProgress,
	Divider,
	// ListItem,
	// ListItemText,
	Tabs,
	Tab
} from 'material-ui';

import Fade from 'material-ui/transitions/Fade';

// import CheckBoxOutlineBlankIcon from 'material-ui-icons/CheckBoxOutlineBlank';
// import CheckBoxIcon from 'material-ui-icons/CheckBox';
// import CloseIcon from 'material-ui-icons/Close';

import Head from '../../components/Head';
import JobCardHeader from '../../components/JobCardHeader';
import LoggedOutCard from '../../components/LoggedOutCard';
import EmptyState from '../../components/EmptyState';
import UnauthorizedText from '../../components/UnauthorizedText';
import SkeletonSectionTitle from '../../components/SkeletonSectionTitle';
import SkeletonCard from '../../components/SkeletonCard';

import { Green, Title } from '../../helper/consts';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	checkedAvatar: {
		backgroundColor: Green
	},
	sumRow: {
		display: 'flex',
		flexWrap: 'wrap'
	}
};

export default class Payouts extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			commissions: {},
			jobs: {},
			checked: [],
			tab: 0
		};
	}

	componentDidMount() {
		this.props.actions.getMyListener([
			{
				uid: '',
				stateName: 'myJobs',
				dbName: 'myJobs',
				dispatchName: 'JobsState/GET_MYJOBS',
				getJobs: true
			}
		]);
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.getInfo();
				this.setState({
					loading: true
				});
			} else {
				firebase
					.database()
					.ref('commissions')
					.off();
				this.setState({
					loading: true
				});
			}
		});
	}

	componentWillUnmount() {
		firebase
			.database()
			.ref('commissions')
			.off();
	}

	noInfo = () => {
		this.setState({ jobs: {}, loading: false });
		this.props.actions.setSnack(true, `Error: Please try again`);
	};

	getJob = jid => {
		return firebase
			.firestore()
			.collection('jobs')
			.doc(jid)
			.get();
	};

	getInfo = () => {
		const ref = firebase.database().ref();
		ref
			.child(`myJobs/${this.props.uid}`)
			.once('value')
			.then(myJobsSnap => {
				console.log(myJobsSnap.val());
				if (!myJobsSnap.val()) {
					return this.noInfo();
				} else {
					const { jobs } = this.state;
					let promises = [];
					let count = myJobsSnap.numChildren();
					myJobsSnap.forEach(myJob => {
						const { jid } = myJob.val();
						const jobPromise = ref
							.child(`commissions/${jid}`)
							.once('value')
							.then(commissionSnap => {
								if (!!commissionSnap.val()) {
									this.props.actions.getJob(jid);
									this.getJob(jid).then(job => {
										jobs[jid] = job.data();
										jobs[jid].commissions = commissionSnap.val();
										this.setState({ jobs });
									});
								}
							});
						promises.push(jobPromise);
						count--;
						if (count === 0) {
							Promise.all(promises).then(() =>
								this.setState({ jobs, loading: false })
							);
						}
					});
				}
			});
	};

	// getInfo = () => {
	//   const ref = firebase.database().ref();
	//   const { jobs } = this.state;
	//   ref.child("commissions").on(
	//     "value",
	//     snap => {
	//       if (snap.val() !== null) {
	//         snap.forEach(jid => {
	//           // ref.child(`jobs/${jid.key}`).once('value')
	//           firebase
	//             .firestore()
	//             .collection("jobs")
	//             .doc(jid.key)
	//             .get()
	//             .then(jobSnap => {
	//               jobs[jid.key] = jobSnap.data();
	//               this.setState({
	//                 jobs,
	//                 commissions: snap.val(),
	//                 loading: false
	//               });
	//             })
	//             .catch(jobError => {
	//               console.log(jobError);
	//             });
	//         });
	//       } else {
	//         this.setState({ loading: false });
	//       }
	//     },
	//     commissionError => {
	//       console.log(commissionError);
	//     }
	//   );
	// };

	// renderJobs = () => {
	// 	const { jobs, commissions } = this.state;
	// 	let html = [];
	// 	for (let job in jobs) {
	// 		let item = (
	// 			<ListItem
	// 				key={jobs[job].jid}
	// 				button
	// 				disableRipple
	// 				onClick={() => {
	// 					this.state.selected === jobs[job].jid
	// 						? this.setState({ selected: '', checked: [] })
	// 						: this.setState({ selected: jobs[job].jid, checked: [] });
	// 				}}
	// 			>
	// 				<Avatar>
	// 					<CheckBoxIcon />
	// 				</Avatar>
	// 				<ListItemText primary={`${jobs[job].title} @ ${jobs[job].company}`} />
	// 				<Button disableRipple>
	// 					{this.state.selected === jobs[job].jid ? 'Close' : 'View'}
	// 				</Button>
	// 			</ListItem>
	// 		);
	// 		html.push(item);
	// 		if (this.state.selected === jobs[job].jid) {
	// 			let selectedCommissions = commissions[this.state.selected];
	// 			for (let uid in selectedCommissions) {
	// 				let user = (
	// 					<ListItem
	// 						key={uid}
	// 						button
	// 						disableRipple
	// 						onClick={() => {
	// 							this.handleCheck(uid);
	// 						}}
	// 					>
	// 						{selectedCommissions[uid].status === 'declined' ? (
	// 							<Avatar>
	// 								<CloseIcon />
	// 							</Avatar>
	// 						) : null}
	// 						{selectedCommissions[uid].status === 'requested' ? (
	// 							<Avatar>
	// 								<CheckBoxOutlineBlankIcon />
	// 							</Avatar>
	// 						) : null}
	// 						{selectedCommissions[uid].status === 'paid' ? (
	// 							<Avatar style={style.checkedAvatar}>
	// 								<CheckBoxIcon />
	// 							</Avatar>
	// 						) : null}
	// 						<ListItemText
	// 							primary={`$${selectedCommissions[uid].commission.toFixed(2)}`}
	// 						/>
	// 						{selectedCommissions[uid].status === 'requested' ? (
	// 							<Checkbox
	// 								checked={
	// 									this.state.checked.indexOf(uid) !== -1 &&
	// 									jobs[job].jid === this.state.selected
	// 								}
	// 								tabIndex={-1}
	// 								disableRipple
	// 							/>
	// 						) : null}
	// 					</ListItem>
	// 				);
	// 				html.push(user);
	// 			}
	// 			html.push(<Divider key={`${jobs[job].jid}_divider`} />);
	// 		}
	// 	}
	// 	return html;
	// };

	//secondary={(<Link to={`/Commission/${jobs[job].jid}`}>View</Link>)}

	// renderSum = () => {
	// 	const { checked, commissions, selected } = this.state;
	// 	let html = [];
	// 	let sum = 0;
	// 	let amount = 0;
	// 	let counter = 0;
	// 	if (checked.length > 0) {
	// 		checked.forEach(uid => {
	// 			counter++;
	// 			commissions[selected][uid] !== undefined
	// 				? (amount = commissions[selected][uid].commission)
	// 				: (amount = 0);
	// 			sum = sum + amount;
	// 			if (counter === checked.length) {
	// 				let item = (
	// 					<ListItemText key={'sum'} primary={`Total: $${sum.toFixed(2)}`} />
	// 				);
	// 				html.push(item);
	// 				return html;
	// 			}
	// 		});
	// 	}
	// };

	// handleCheck = uid => {
	// 	let { checked } = this.state;
	// 	let i = checked.indexOf(uid);
	// 	i === -1 ? checked.push(uid) : checked.splice(i, 1);
	// 	this.setState({ checked });
	// };

	// updateStatus = status => {
	// 	const { checked, selected } = this.state;
	// 	let promises = [];
	// 	const ref = firebase.database().ref();
	// 	checked.forEach(uid => {
	// 		const jid = selected;
	// 		let commissionPromise = '';
	// 		status === 'pending'
	// 			? (commissionPromise = ref
	// 					.child(`commissions/${jid}/`)
	// 					.update({ [uid]: null }))
	// 			: (commissionPromise = ref
	// 					.child(`commissions/${jid}/${uid}/`)
	// 					.update({ status }));
	// 		// let commissionPromise = ref.child(`commissions/${jid}/${uid}/`).update({status})
	// 		promises.push(commissionPromise);
	// 		let myCommissionsPromise = ref
	// 			.child(`myCommissions/${uid}/${jid}/`)
	// 			.update({ status });
	// 		promises.push(myCommissionsPromise);
	// 	});
	// 	Promise.all(promises)
	// 		.then(() => {
	// 			this.setState({ checked: [] });
	// 		})
	// 		.catch(err => {
	// 			console.log(err);
	// 		});
	// };

	handleTabChange = (e, value) => this.setState({ tab: value });

	renderTabs = () => {
		let html = [];
		let tabs = (
			<Tabs
				value={this.state.tab || 0}
				onChange={this.handleTabChange}
				indicatorColor="primary"
				textColor="primary"
				centered
				key="jobs_tabs"
			>
				<Tab
					onClick={() => {
						this.setState({ archives: false });
					}}
					label="Pending"
				/>
				<Tab
					onClick={() => {
						this.setState({ archives: true });
					}}
					label="Paid"
				/>
			</Tabs>
		);
		html.push(tabs);
		return html;
	};

	checkCommissions = commissions => {
		const status = ['requested', 'paid'];
		const { tab } = this.state;
		return (
			Object.keys(commissions)
				.map(uid => commissions[uid])
				.map(commission => commission.status)
				// .forEach(commissionStatus=>console.log(commissionStatus===status[tab]))
				.some(commissionStatus => commissionStatus === status[tab])
		);
	};

	renderPayouts = () => {
		let html = [];
		let { jobs, tab } = this.state;
		let filteredJobs = Object.keys(jobs)
			.map(jid => jobs[jid])
			.filter(job => !!job.commissions)
			.filter(job => !!this.checkCommissions(job.commissions));
		if (_.isEmpty(filteredJobs))
			return (
				<EmptyState
					key="no payouts"
					subject={tab === 0 ? 'No Pending Payouts' : 'No Paid Payouts'}
					message={'Share an active job today to recieve applicants.'}
					btnDestination={'/Jobs'}
					btnMsg={'Jobs'}
				/>
			);
		filteredJobs.forEach(job => {
			// console.log(job);
			let card = (
				<Fade key={job.jid} in={true}>
					<Card className="card">
						<JobCardHeader job={job} />
						<Divider light />
						<CardActions className="cardActions">
							<Link to={`/Payout/${job.jid}`}>
								<Button raised className="cardActionsBtn">
									View
								</Button>
							</Link>
						</CardActions>
					</Card>
				</Fade>
			);
			html.push(card);
		});
		return html;
	};

	render() {
		// console.log(this.state);
		// console.log(this.props);
		return (
			<React.Fragment>
				<Head title={`Payouts | ${Title}`} />
				<div id={this.props.loggedIn ? 'loggedInBody' : null} className="body">
					{this.props.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}

					{!this.props.authLoading &&
						this.props.loggedIn &&
						this.props.admin &&
						this.state.loading && <SkeletonSectionTitle />}
					{!this.props.authLoading &&
						this.props.loggedIn &&
						this.props.admin &&
						!this.state.loading &&
						this.renderTabs()}

					{!this.props.authLoading &&
						this.props.loggedIn &&
						this.props.admin &&
						this.state.loading && <SkeletonCard header={true} />}
					{!this.props.authLoading &&
						this.props.loggedIn &&
						this.props.admin &&
						!this.state.loading &&
						this.renderPayouts()}

					{!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						!this.props.admin && (
							<div className="unauthorizedTextContainer">
								<UnauthorizedText
									text="Unauthorized"
									subText="Access is limited"
								/>
							</div>
						)}

					{!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Payouts/Payouts.js